import authService from './authService'
import axios from 'axios'

export default {
  async createMap (sql, options) {
    const config = {
      layers: [{
        type: 'mapnik',
        options: {
          sql,
          vector_extent: 2048,
          vector_simplify_extent: 2048,
          metadata: {
            geometryType: true
          },
          ...options
        }
      }]
    }

    try {
      const response = await this.makeMapsApiRequest(config)
      return response
    } catch (error) {
      throw new Error(`[layerService.js] Failed to connect to Maps API with your user: ${error}`)
    }
  },
  makeMapsApiRequest (config) {
    const { api_base_url: base, apikey } = authService.getAuth()
    const url = `${base}/api/v1/map?api_key=${apikey}`
    const getUrl = `${url}&client=vl-1.4.4&config=${JSON.stringify(config)}`
    if (getUrl.length > 1024) {
      return axios.post(url, config).then(res => res.data)
    } else {
      return axios.get(getUrl).then(res => res.data)
    }
  }
}
